import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';
import { EPermissions } from '@app/models/permissions.enum';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  access = new BehaviorSubject(null);
  institutionaccess = new BehaviorSubject(null);
  userid;
  memberid;
  admininstitutionid;
  memberlodge;
  membercamp;
  institutionid;
  loggedin = new BehaviorSubject(false);

  memberinstitutions: any[] = [];
  constructor(private http: HttpClient, private router: Router, private permissionsService: PermissionsService) {
    this.userid = +JSON.parse(sessionStorage.getItem('userid'));
   }
  permissions = new BehaviorSubject(null);
  test = new BehaviorSubject(null);
  permissionslist: string[] = [];

  userpermissions = new BehaviorSubject(null);
  selectedrole = new BehaviorSubject(null);
  selectedindex = new BehaviorSubject(0);
  roleidx = 0;
  permissions$ = new BehaviorSubject(null);
 
 

  setPermissionsInLocalStorage(permissions: string) {
    localStorage.setItem('permissions', permissions);
  }
  getPermissionsFromLocalStorage() {
    return localStorage.getItem('permissions');
  }

  getListOfClaims() {
    this.permissionslist = [];
    this.permissions$.getValue().claimsList.forEach(element => {
      this.permissionslist.push(element.key);
    });
    return this.permissionslist;
  }

  getActiveRole() {
    return this.http.get<any>(environment.apiUrl + 'Permission/GetActiveRole');
  }

  getUserPermissionAsync() {
    
    return this.http.get<any>(environment.apiUrl + 'Permission/GetUserPermissionAsync');
  }

  hasPermissionForMember(permission: string, memberid: number) {
    return this.http.get<any>(environment.apiUrl + 'Permission/hasPermissionForMember/' + permission + '/' + memberid);
  }

  hasPermissionForInstitution(permission: string, institutionid: number) {
    return this.http.get<any>(environment.apiUrl + 'Permission/hasPermissionForInstitution/' + permission + '/' + institutionid);
  }

  setSelectedRole(idx) {
    this.selectedindex.next(idx);
    if (this.userpermissions.value !== null) {
      let role = this.userpermissions.value.userRoles[idx];
      if (!role) {
        role = this.userpermissions.value.userRoles[0];
        this.setSelectedRole(role.roleId);
      }
      const accesses = {
        userPermissionLevel: role?.userPermissionLevel,
        userDomain: role?.userDomain,
        roleId: role?.roleId,
        roleDescription: role?.roleDescription,
        canSeeReportMenu: role?.canSeeReportMenu,
        canSeeReportSubmenuAttendance: role?.canSeeReportSubmenuAttendance,
        canSeeReportSubmenuReports: role?.canSeeReportSubmenuReports,
        canSeeReportSubmenuStatistics: role?.canSeeReportSubmenuStatistics,
        officeEmail: role?.officeEmail,
        institutionEmail: role?.institution?.email,
        institution: {
          id: role?.institution?.id,
          institutionTypeId: role?.institution?.institutionTypeId,
          institutionNumber: role?.institution?.institutionNumber,
          shortName: role?.institution?.shortName,
          name: role?.institution?.name
        },
        permissions: role?.permissions
      };
      
      this.selectedrole.next(accesses);
      
      sessionStorage.setItem('selectedrole', JSON.stringify(accesses));
    }
  }

  setMemberAccess() {
  
    const role = this.selectedrole.getValue();
    this.userid = +JSON.parse(sessionStorage.getItem('userid'));
    const access = {
      userid: this.userid,
      memberid: this.memberid,
      role: role,
      admininstitutionid: this.admininstitutionid,
      memberlodge: this.memberlodge,
      membercamp: this.membercamp,
      memberinstitutions: this.memberinstitutions,
      change_my_password: this.userid === this.memberid,
      // tslint:disable-next-line: max-line-length
      change_members_password: (role?.permissions?.includes(EPermissions.CHANGE_PASSWORD) && role?.userPermissionLevel === 'SY') || (role?.permissions?.includes(EPermissions.CHANGE_PASSWORD) && role?.userPermissionLevel === 'IN' && role?.userDomain === 'LODGE' && this.memberlodge === this.admininstitutionid) || (role?.permissions?.includes(EPermissions.CHANGE_PASSWORD) && role?.userPermissionLevel === 'IN' && role?.userDomain === 'CAMP' && this.membercamp === this.admininstitutionid),
      // tslint:disable-next-line: max-line-length
      view_matrix_card: (role?.permissions?.includes(EPermissions.VIEW_MATRIX_CARD) && (role?.userPermissionLevel === 'IN' && role?.institution.id === this.memberlodge) || (role?.userPermissionLevel === 'IN' && role?.institution.id === this.membercamp)) || this.userid === this.memberid,
      // tslint:disable-next-line: max-line-length
      view_menubar: role?.userPermissionLevel === 'SY' || (role?.userPermissionLevel === 'IN' && role?.userDomain === 'LODGE' && this.memberlodge === this.admininstitutionid) || (role?.userPermissionLevel === 'IN' && role?.userDomain === 'CAMP' && this.membercamp === this.admininstitutionid),
      // tslint:disable-next-line: max-line-length
      view_memberfees: this.memberid === this.userid,
      // tslint:disable-next-line: max-line-length
      edit_baseinfo: role?.permissions?.includes('EDIT_MEMBER_BASEINFO') && (role.userPermissionLevel === 'SY' || this.admininstitutionid === this.memberlodge || this.admininstitutionid === this.membercamp || this.memberid === this.userid),
      // tslint:disable-next-line: max-line-length
      edit_photo: (role?.userPermissionLevel === 'SY' || role?.userDomain === 'LODGE' && this.memberlodge === this.admininstitutionid || role?.userDomain === 'CAMP' && this.membercamp === this.admininstitutionid),
      // tslint:disable-next-line: max-line-length
      edit_member_baseinfo_readonly: role?.permissions?.includes(EPermissions.EDIT_MEMBER_BASEINFO) || role?.userPermissionLevel === 'SY' || (role?.userPermissionLevel === 'IN' && role?.institution.id === this.memberlodge),
      send_email: role?.permissions?.includes(EPermissions.SEND_EMAIL),
      view_postals: role?.permissions?.includes(EPermissions.VIEW_POSTALS),
      edit_own_info: this.memberid === this.userid
    };
   
    this.access.next(access);
  }

  setInstitutionAccess() {
    const role = this.selectedrole.getValue();
    const x = role?.userPermissionLevel;
    const y = this.admininstitutionid;
    const access = {
      // tslint:disable-next-line: max-line-length
      edit_institution: role?.permissions.includes(EPermissions.EDIT_INSTITUTION) && (role.userPermissionLevel === 'SY' || this.admininstitutionid === this.institutionid),
      create_institution: role?.permissions.includes(EPermissions.CREATE_INSTITUTION),
      // tslint:disable-next-line: max-line-length
      add_offices: role?.permissions.includes(EPermissions.EDIT_MEMBER_OFFICES) && (role.userPermissionLevel === 'SY' || role.institution.id === this.institutionid),
      // tslint:disable-next-line: max-line-length
      add_offices2: role?.permissions.includes(EPermissions.EDIT_MEMBER_OFFICES) && (role.userPermissionLevel === 'SY' || this.memberinstitutions.indexOf(this.admininstitutionid) !== -1),
      // tslint:disable-next-line: max-line-length
      add_signs: role?.permissions.includes(EPermissions.EDIT_MEMBER_SIGNS) && (role.userPermissionLevel === 'SY' || this.admininstitutionid === this.institutionid),
      // tslint:disable-next-line: max-line-length
      add_signs2: role?.permissions.includes(EPermissions.EDIT_MEMBER_SIGNS) && (role.userPermissionLevel === 'SY' || this.memberinstitutions.indexOf(this.admininstitutionid) !== -1),
      view_memfee: role?.permissions.includes(EPermissions.VIEW_MEMFEE),
      view_meeting_details: role?.permissions.includes(EPermissions.VIEW_MEETING_DETAILS),
      admininstitutionid: this.admininstitutionid,
      institutionid: this.institutionid,
      memberlodge: this.memberlodge,
      // tslint:disable-next-line: max-line-length
      add_member_memberships: role?.permissions.includes(EPermissions.ADD_MEMBER_MEMBERSHIPS) && (role.userPermissionLevel === 'SY' || this.admininstitutionid === this.institutionid),
      // tslint:disable-next-line: max-line-length
      insert_member_orden: role?.permissions.includes(EPermissions.INSERT_MEMBER) && (role.userPermissionLevel === 'SY' || (role.userPermissionLevel === 'IN' && role.userDomain === 'LODGE' && this.admininstitutionid === this.institutionid)),

      // tslint:disable-next-line: max-line-length
      add_member_to_camp: role?.permissions.includes(EPermissions.ADD_MEMBER_MEMBERSHIPS) && (role.userPermissionLevel === 'SY' || (role.userDomain === 'CAMP' && this.admininstitutionid === this.institutionid))
    };
    this.institutionaccess.next(access);
  }

  getEditMemberBaseInfoReadonly(role) {
    if (role?.permissions.includes('EDIT_MEMBER_BASEINFO')) {
      if (role.userPermissionLevel === 'SY') {
        return false;
        // tslint:disable-next-line: max-line-length
      } else if (role.userPermissionLevel === 'IN' && (role.institution.id === this.memberlodge || role.institution.id === this.membercamp)) {
        return false;
      } else {
        return true;
      }
    }
  }

  changeActiveRole(roleid: number, index: number) {
    return this.http.get<any>(environment.apiUrl + 'Permission/ChangeActiveRole/' + roleid + "/" + index);
  }
   impersonate(userid: string) {
    return this.http.get<any>(environment.apiUrl + 'Permission/Impersonate/' + userid);
  }
}
